var _g, _g2, _g3, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 984,
    viewBox: "0 0 1008 984",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_862_365)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 504,
    cy: 455.29,
    rx: 303,
    ry: 254.29,
    fill: "url(#paint0_linear_862_365)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_862_365)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.411,
    y: 436.063,
    width: 291.176,
    height: 346.703,
    fill: "url(#paint1_linear_862_365)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_862_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.91 485.141C371.416 566.93 452.113 618.369 533.151 600.033C614.19 581.697 664.882 500.529 646.376 418.741C627.871 336.952 547.174 285.513 466.136 303.849C385.097 322.186 334.405 403.353 352.91 485.141Z",
    fill: "url(#paint2_linear_862_365)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353 485.121C371.494 566.862 452.143 618.268 533.131 599.943C614.119 581.619 664.782 500.501 646.287 418.761C627.792 337.021 547.144 285.614 466.156 303.939C385.167 322.263 334.505 403.381 353 485.121Z",
    stroke: "url(#paint3_linear_862_365)",
    strokeWidth: 0.183016,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540.294 416.526C536.882 400.343 522.298 396.36 504.491 396.691L501.915 374.012L488.259 375.479L490.766 397.561C487.176 397.947 483.514 398.412 479.876 398.878L477.356 376.649L463.706 378.114L466.274 400.788C463.324 401.166 460.426 401.533 457.595 401.839L457.585 401.769L438.748 403.785L440.425 418.528C440.425 418.528 450.488 417.251 450.342 417.457C455.874 416.865 458.043 419.918 458.884 422.663L461.818 448.5C462.2 448.461 462.7 448.424 463.272 448.441C462.817 448.491 462.33 448.54 461.83 448.598L465.934 484.793C465.891 486.579 465.186 489.495 461.322 489.917C461.514 490.054 451.394 490.98 451.394 490.98L450.552 507.759L468.324 505.849C471.632 505.499 474.893 505.206 478.09 504.882L480.699 527.821L494.342 526.358L491.766 503.662C495.521 503.338 499.149 502.979 502.688 502.597L505.245 525.187L518.903 523.722L516.309 500.824C539.118 497.026 554.524 489.454 554.047 467.447C553.665 449.723 544.611 442.769 531.219 441.004C538.675 436.078 542.81 428.366 540.294 416.526ZM526.752 467.624C528.706 484.766 499.447 485.931 490.192 486.934L486.747 456.543C496.005 455.551 524.725 449.745 526.752 467.624ZM515.534 425.428C517.3 441.024 492.877 441.803 485.167 442.632L482.04 415.068C489.75 414.239 513.686 409.162 515.534 425.428Z",
    fill: "url(#paint4_linear_862_365)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_862_365",
    x: 0.00495911,
    y: 0.00495911,
    width: 1007.99,
    height: 910.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100.498,
    result: "effect1_foregroundBlur_862_365"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_862_365",
    x: 157.416,
    y: 235.068,
    width: 693.166,
    height: 748.693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100.498,
    result: "effect1_foregroundBlur_862_365"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_862_365",
    x: 342.135,
    y: 291.003,
    width: 349.897,
    height: 315.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 41.8452,
    dy: -9.13797
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.8602
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.0338542 0 0 0 0 0.0338542 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_862_365"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.96491,
    dy: 2.78597
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4581
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.829417 0 0 0 0 0.629167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_862_365",
    result: "effect2_innerShadow_862_365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_365",
    x1: 504,
    y1: 201,
    x2: 504,
    y2: 709.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF543E",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4A22",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_365",
    x1: 503.999,
    y1: 436.063,
    x2: 503.999,
    y2: 782.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD55",
    stopOpacity: 0.11
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_862_365",
    x1: 616.108,
    y1: 379.302,
    x2: 343.084,
    y2: 532.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB263",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_862_365",
    x1: 1589.88,
    y1: 108.891,
    x2: 1656.89,
    y2: 405.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_862_365",
    x1: 420.001,
    y1: 422.313,
    x2: 572.261,
    y2: 505.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.1971a8398f085c15a93a5b1fdaa56efe.svg";
export { ForwardRef as ReactComponent };